<template>
  <div>
    <div class="flex justify-center my-20">
      <h4>This is the Overview page</h4>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>
